import React from "react";
import styled from "styled-components";

export default function BlogBox({
  tag,
  title,
  text,
  author,
  image,
  onReadMore,
}) {
  const preview = text?.length > 200 ? `${text.substring(0, 200)}...` : text;

  return (
    <Card className="whiteBg radius8 shadow">
      {/* Header row: avatar + pills (role + residence) */}
      <TopRow>
        {image && <Avatar src={image} alt={`${title} profile photo`} />}
        <Meta>
          {author && <Tag>{author}</Tag>}
          {tag && <Tag>{tag}</Tag>}
        </Meta>
      </TopRow>

      {/* Body */}
      <Content>
        <h3 className="font20 extraBold">{title}</h3>

        <p className="font13" style={{ padding: "12px 0" }}>
          {preview}
        </p>

        {text?.length > 160 && (
          <ReadMoreBtn onClick={onReadMore}>Read more</ReadMoreBtn>
        )}
      </Content>
    </Card>
  );
}

/* ===== styled-components ===== */

const Card = styled.div`
  width: 100%;
  text-align: left;
  margin-top: 30px;
  border-radius: 16px;
  padding: 16px; /* soft card padding to match rounded look */
`;

const TopRow = styled.div`
  display: grid;
  grid-template-columns: 96px 1fr;
  align-items: center;
  gap: 16px;
`;

const Avatar = styled.img`
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 16px; /* rounded corners like your screenshot */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
`;

const Meta = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const Tag = styled.span`
  background: #eef2ff; /* light indigo-like */
  color: #3730a3; /* deep indigo text */
  padding: 8px 14px;
  border-radius: 9999px; /* pill */
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
`;

const Content = styled.div`
  padding: 12px 8px 0;
`;

const ReadMoreBtn = styled.button`
  background: #111827;
  color: #fff;
  border: 0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;

  &:hover {
    filter: brightness(1.05);
  }
`;
